export const ELEMENT_TYPES = [
  { type: "header", label: "Heading", icon: "H1" },
  { type: "para", label: "Paragraph", icon: "T" },
  { type: "btn", label: "Button", icon: "Btn" },
  { type: "image", label: "Image", icon: "Img" },
  { type: "icon", label: "Icon", icon: "★" },
  { type: "video", label: "Video", icon: "▶" },
];
